<template>
    <div>
        <v-fade-transition>
            <v-card v-if="viewReportsModal" class="view-reports-modal mhbu" elevation="6">
                <v-card-title>
                    <h2>{{ t('reports::trackers.reports.mhbu.modal.title') }}</h2>
                    <v-icon color="rgba(0,0,0,0.32)" size="24" @click="viewReportsModal = false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="reports">
                    <div class="h-100">
                        <label v-if="reports && reports.length" class="label" for="date">{{
                            t('quality-control::nequas.label.date')
                        }}</label>
                        <div class="d-flex flex-column justify-content-between" style="height: 96%">
                            <v-list v-if="reports && reports.length" style="background-color: transparent !important">
                                <template v-for="(report, index) in reports">
                                    <div :key="index" class="report">
                                        <div class="report-wrap">
                                            <div class="copy">
                                                <div v-if="report.file_name" class="name">
                                                    {{ report.file_name }}
                                                </div>
                                            </div>
                                            <div class="actions">
                                                <v-tooltip
                                                    v-if="can('neqas-reports.download')"
                                                    top
                                                    transition="v-fab-transition"
                                                >
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn
                                                            color="rgba(0,0,0,0.34)"
                                                            icon
                                                            v-bind="attrs"
                                                            small
                                                            v-on="on"
                                                            @click="downloadReport(report)"
                                                        >
                                                            <v-icon size="22">mdi-download</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ t('quality-control::button.download_file') }}</span>
                                                </v-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-list>
                            <v-list v-else class="h-100" style="background-color: transparent !important">
                                <v-list-item class="p-0">
                                    <v-list-item-title
                                        >{{ t('quality-control::nequas.reports.modal.no.data.text') }}
                                    </v-list-item-title></v-list-item
                                >
                            </v-list>
                            <div
                                v-if="meta && meta.pagination"
                                v-show="meta.pagination.total_items > 0"
                                class="pagination"
                            >
                                <v-pagination
                                    v-model="meta.pagination.current_page"
                                    :length="meta.pagination.total_pages"
                                    circle
                                    color="amber"
                                    total-visible="8"
                                    @input="fetchReportsList"
                                ></v-pagination>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-fade-transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            viewReportsModal: false,
            downloadingFile: false,
        };
    },
    computed: {
        reports() {
            return this.$store.state.trackers.mhbuReportsList;
        },
        meta() {
            return this.$store.state.trackers.mhbuReportsMeta;
        },
    },
    watch: {
        viewReportsModal(modal) {
            this.$root.setAppOverLay(modal);
        },
    },
    mounted() {},
    methods: {
        fetchReportsList(page = 1) {
            this.$store.dispatch('trackers/fetchMhbuReportsList', { page });
        },
        downloadReport(report) {
            if (this.downloadingFile) {
                return;
            }

            this.downloadingFile = true;

            return axios
                .get(route('reports.mhbu.download', { report: report.id }))
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = response.request.responseURL;
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    this.$root.notify(
                        'error',
                        t('quality-control::nequas.grid.generate.report.fail'),
                        error.response.data.error
                    );
                })
                .finally(() => {
                    _.delay(() => {
                        this.downloadingFile = false;
                    }, 2000);
                });
        },
    },
};
</script>
